import { render } from "./Users.vue?vue&type=template&id=858aa18a&scoped=true"
import script from "./Users.vue?vue&type=script&lang=js"
export * from "./Users.vue?vue&type=script&lang=js"

import "./Users.vue?vue&type=style&index=0&id=858aa18a&scoped=true&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=1&lang=css"
script.render = render
script.__scopeId = "data-v-858aa18a"

export default script